import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeSore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 199,
	height: 205,
	viewBox: "0 0 199 205",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M147.64 -9.45966C118.959 -6.48718 90.1709 -9.62486 61.4377 -6.55993C52.9213 -4.537 -1.22211 -1.07462 5.77489 11.4927C13.9958 17.5637 29.2735 4.99874 34.4497 8.86828C36.43 12.8599 22.8528 17.7989 20.1099 20.7462C14.4367 24.5741 5.65121 35.2857 19.3601 32.4613C27.3468 30.8757 32.8696 25.203 39.3665 20.9731C46.4548 21.4812 38.9041 28.4377 36.0363 29.975C33.0852 31.9103 31.3311 34.6679 30.1075 37.8501C27.3731 43.6122 28.0751 53.6367 36.5614 47.9494C42.5612 42.7046 45.4365 35.0731 49.466 28.3803C52.3902 22.3814 76.4732 20.3816 83.6537 18.8585C86.3291 18.6269 88.8954 19.3085 91.5519 18.2294C93.5262 17.0048 96.0247 17.8796 98.1874 17.6496C105.7 15.0175 114.055 15.9679 121.915 14.9182C129.646 14.506 125.121 18.7156 124.726 23.0682C124.167 31.9708 121.613 42.7999 128.233 50.0508C136.087 62.7459 151.304 69.6076 166.049 69.3303C170.793 69.2239 175.631 69.2763 180.127 67.5222C182.098 67.0494 185.408 65.2682 186.53 67.7639C186.591 71.307 177.023 71.5595 174.249 72.2543C151.842 75.6984 120.703 64.3982 118.333 39.0947C118.863 13.628 132.781 19.2486 90.5024 23.3866C78.2937 24.123 66.5526 27.895 54.7564 30.872C49.7369 33.705 48.5573 40.9542 44.5541 45.0733C40.0622 51.014 27.4447 58.5388 24.7515 47.3285C23.5047 44.4382 27.5251 35.9813 25.5228 35.7544C19.0114 39.0505 2.70039 39.3544 8.304 28.1966C9.93501 24.9701 12.3061 22.3378 14.82 19.795C15.445 19.163 16.6214 18.8494 16.3677 17.5851C3.27469 18.929 -7.30956 11.3018 6.46256 0.966574C14.3058 -4.31787 23.8826 -5.04345 32.9017 -7.0019C59.5498 -11.5031 86.439 -13.5232 113.497 -12.8847C124.816 -10.8206 136.613 -12.9012 147.64 -9.45966Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M128.151 189.636C124.099 188.099 115.786 190.762 115.15 184.85C114.682 179.964 119.384 178.023 122.279 175.286C118.049 173.745 111.686 175.044 108.466 170.617C104.921 164.703 112.018 157.85 118.082 158.357C130.997 159.288 144.042 159.721 156.975 158.858C176.617 158.474 184.565 155.513 184.229 134.164C185.162 117.121 184.173 100.221 182.302 83.2803C182.29 79.8607 181.776 74.702 184.413 72.397C187.166 78.0936 185.822 85.8572 187.536 92.2137C190.224 107.276 188.562 122.724 188.528 137.931C189.433 165.78 164.62 164.393 143.791 164.367C135.129 164.318 126.494 163.459 117.881 162.872C115.015 162.644 109.179 167.304 113.162 169.376C120.43 171.319 128.149 169.292 135.386 171.241C139.05 171.115 143.638 175.026 137.466 175.419C132.306 175.497 120.801 178.492 120.153 184.145C126.406 186.126 134.332 186.486 140.77 184.438C142.175 184.039 143.291 184.478 144.254 185.537C146.441 188.109 141.837 188.817 140.158 189.43C116.83 199.276 131.794 202.634 147.516 198.247C150.045 197.809 150.944 201.346 153.776 200.682C168.784 201.815 183.469 198.504 198.271 197.269C210.781 195.327 210.344 190.765 213.865 180.141C217.123 171.987 215.31 163.094 216.996 154.602C218.357 150.837 214.728 136.867 222.041 139.798C224.52 147.875 221.321 157.407 222.065 166.007C222.515 175.409 218.936 191.586 212.321 198.422C204.444 203.991 193.381 201.323 184.345 203.687C171.369 206.376 158.253 204.054 145.171 204.341C138.064 204.869 121.018 206.753 123.504 195.354C124.3 192.699 127.388 192.077 128.151 189.636Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M170.016 52.8075C188.051 54.171 196.344 43.5574 195.111 26.9259C191.055 13.658 175.348 11.2676 163.231 10.2544C146.95 9.52011 141.126 26.055 144.092 39.7502C145.937 50.3417 161.969 52.6675 170.016 52.8075ZM170.235 56.5042C159.14 55.9911 145.606 54.687 139.931 43.6509C133.451 23.991 144.898 2.55555 167.168 4.47734C180.61 7.45031 189.588 6.61399 198.156 19.5999C203.109 28.1768 199.835 40.375 194.546 48.2125C189.001 55.1779 178.658 56.4514 170.235 56.5042Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M173.97 112.695C173.109 116.271 162.676 132.143 160.779 122.971C162.088 120.501 173.102 103.885 173.97 112.695Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M82.4591 46.8197C77.7494 46.3064 73.7532 44.6024 70.4884 41.356C69.6957 40.0874 65.5716 37.3609 67.9052 36.2169C71.0859 33.832 89.7121 45.373 82.4591 46.8197Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M157.761 99.4642C158.746 99.4451 160.384 100.241 159.005 101.302C155.81 103.314 153.394 106.267 150.354 108.466C147.869 111.693 140.655 112.246 143.522 106.678C147.578 103.088 152.141 99.8437 157.761 99.4642Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M111.09 101.936C107.433 102.087 102.8 100.576 108.334 98.3642C114.694 97.5331 121.206 95.4143 127.593 95.781C128.936 96.3831 127.591 97.3822 127.198 98.019C124.808 101.915 115.255 101.107 111.09 101.936Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M169.741 91.6546C167.384 91.8223 149.086 89.3835 154.215 85.8062C159.825 85.8833 165.466 86.8923 170.836 88.4905C175.029 90.0152 173.89 92.2967 169.741 91.6546Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M92.9069 47.0681C87.4758 46.5803 97.6926 35.64 100.484 35.4616C102.41 34.4251 106.125 34.7069 103.779 37.3021C100.162 40.3543 97.6754 46.0146 92.9069 47.0681Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M94.8248 78.6757C94.0593 86.2129 82.8913 73.961 85.8716 70.8546C91.918 68.8407 93.9786 74.0617 94.8248 78.6757Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M143.649 128.766C147.019 129.093 158.852 132.603 157.997 136.606C157.897 139.562 137.059 130.781 143.649 128.766Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M126.474 121.019C112.077 121.138 131.299 115.647 135.516 117.087C142.239 119.036 128.827 122.32 126.474 121.019Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M134.899 80.3429C131.399 79.7325 127.722 77.6755 125.772 74.6628C125.1 72.5378 128.573 73.2018 129.711 73.3835C132.094 73.4478 140.137 79.2319 134.899 80.3429Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M116.726 67.5461C114.507 71.8127 110.029 64.9906 108.845 62.6981C107.854 60.9386 109.199 58.4174 111.309 59.4949C114.053 61.1644 115.819 64.5626 116.726 67.5461Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M144.353 140.809C143.042 142.677 136.894 154.609 135.145 148.778C135.931 146.559 142.311 135.663 144.353 140.809Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M84.8727 60.9742C76.7196 60.0101 84.9399 55.2508 88.5212 54.3296C90.1045 53.8552 91.7903 56.3095 90.7912 57.5135C89.3048 59.2989 87.4776 60.6103 84.8727 60.9742Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M114.486 79.2624C114.409 81.3138 112.112 90.9272 109.411 87.1849C108.336 84.3044 113.31 70.4542 114.486 79.2624Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M60.2302 45.2063C59.782 48.6561 55.7639 48.9121 53.3734 50.5438C50.5643 50.6319 58.2619 41.5448 60.2302 45.2063Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M121.191 145.27C119.528 146.068 117.928 143.056 116.522 142.215C113.162 136.281 121.625 142.282 121.191 145.27Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M161.196 30.1192C160.764 40.1511 178.609 35.0185 171.375 27.6993C168.011 25.772 160.745 24.1207 161.196 30.1192ZM157.325 31.3203C156.297 14.9795 181.664 17.8246 177.487 32.6878C173.882 40.4796 157.987 41.1786 157.325 31.3203Z",
			fill: "#79C912",
			fillOpacity: .1
		})
	]
});
export default SvgEyeSore;
